<template>
  <div v-loading="loading">
    <el-row>
      <el-col>
        <table class="table table-striped table-bordered" v-if="order_payments && payments">
          <tbody>
          <tr>
            <td>{{ $t("message.order") }}:</td>
            <td># {{ order_payments.id }}</td>
          </tr>
          <tr>
            <td>{{ $t("message.total_amount") }}:</td>
            <td>{{ order_payments.total_price | formatMoney }}</td>
          </tr>
          <tr>
            <td>{{ $t("message.paid") }}:</td>
            <td>
              {{
                (payments.paid_price ? payments.paid_price : 0)
                    | formatMoney
              }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("message.remaind") }}:</td>
            <td>
              {{ (payments.paid_price
                ? order_payments.total_price - payments.paid_price
                : order_payments.total_price) | formatMoney }}
            </td>
          </tr>
          </tbody>
        </table>
      </el-col>
    </el-row>
    <hr>
    <el-form
        ref="formTransaction"
        :model="form"
        :rules="rules"
        size="mini"
        @keyup.enter.native="submit"
    >
      <el-row :gutter="24">
        <el-col :span="4">
          <el-form-item
              :label="columns.payment_type_id.title"
              prop="payment_type_id"
          >
            <el-select
                v-model="form.payment_type_id"
                filterable
                :placeholder="columns.payment_type_id.title"
            >
              <el-option
                  v-for="item in paymentTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item :label="columns.price.title" prop="price">
            <el-input
                v-model="form.price"
                :placeholder="columns.price.title"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item :label="columns.date.title" prop="date">
            <el-date-picker
                type="date"
                v-model="form.date"
                :format="'dd.MM.yyyy'"
                :value-format="'dd.MM.yyyy'"
                :placeholder="columns.date.title"
                :picker-options="datePickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item :label="columns.comment.title" prop="comment">
            <el-input
                v-model="form.comment"
                :placeholder="columns.comment.title"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-button
              class="mt-4"
              :loading="loadingButton"
              @click="submit()"
              type="success"
          >{{ $t("message.add_transaction") }}</el-button
          >
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import {i18n} from "@/utils/i18n";

export default {
  name: "dialog",
  props: ['order'],
  data() {
    return {
      form: {
        date: new Date(),
        payment_type_id: null,
        price: 0,
        comment: '',
      },
      loadingButton: false,
      order_payments: [],
      payments: null,
      loading: false,
      datePickerOptions: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 8.64e7 * 2;
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      paymentTypes: "paymentTypes/list",
      model: "payment/order_payments",
      columns: "transaction/columns",
      rules: "transaction/rules",
    }),
  },
  methods: {
    ...mapActions({
      save: "payment/paymentStore",
      paymentTypesList: "paymentTypes/index",
      showModel: "payment/relationShow",
    }),
    async loadData() {
      this.loading = true;
      this.paymentTypesList();
      await this.fetchData();
    },
    fetchData() {
      const query = { id: this.order.id, relation: true };
      this.showModel(query)
        .then((res) => {
          this.drawerUpdate = true;
          this.loading = false;
          this.order_payments = JSON.parse(JSON.stringify(this.model));
          this.payments =
              typeof this.model.payments[0] !== "undefined"
                  ? JSON.parse(JSON.stringify(this.model.payments[0]))
                  : [];
        })
        .catch((err) => {});
    },
    submit() {
      console.log('form')
      this.$refs["formTransaction"].validate((valid) => {
        if (valid) {
          this.saveAction(true);
        }
      });
    },
    saveAction(close) {
      let price =
          typeof this.order_payments.payments[0] != "undefined"
              ? this.order_payments.payments[0].paid_price
              : 0;
      let val = this.order_payments.total_price - price;
      let remaining = this.payments.paid_price ? this.order_payments.total_price - this.payments.paid_price : this.order_payments.total_price;
      if (val == NaN && val < 0) {
        this.$notify({
          title: this.$t("message.validation"),
          type: "error",
          offset: 130,
          dangerouslyUseHTMLString: true,
          message: i18n.t("message.overpaid") + " " + val,
        });
        return;
      }
      if (remaining < this.form.price) {
        let dd = this.form.price - remaining;
        this.$notify({
          title: this.$t("message.validation"),
          type: "error",
          offset: 130,
          dangerouslyUseHTMLString: true,
          message: i18n.t("message.overpaid_amount") + " " + dd,
        });
        return;
      }
      if (this.form.price <= 0) {
        this.$notify({
          title: "Внимание ",
          type: "warning",
          offset: 130,
          dangerouslyUseHTMLString: true,
          message: i18n.t("message.set_transaction_amount"),
        });
        return;
      }
      this.form.paymentable_id = this.order_payments.id;
      this.form.paymentable_type = "App\\Order";
      this.form.total_price = this.order_payments.total_price;
      this.form.debit = 1;
      this.form.rate = 1;
      this.loadingButton = true;
      this.save(this.form)
          .then((res) => {
            this.$parent.$parent.listChanged();
            this.loadingButton = false;

            this.$notify({
              title: "Успешно",
              type: "success",
              offset: 130,
              dangerouslyUseHTMLString: true,
              message: res.message,
            });

            this.fetchData();
            this.form = {
              date: new Date(),
            };
            if (close) {
              this.$refs["formTransaction"].resetFields();
            }
          })
          .catch((err) => {
            this.loadingButton = false;
            this.$notify({
              title: "Ошибка",
              type: "error",
              offset: 130,
              message: err.error.message,
            });
          });
    },
  },
}
</script>
<style scoped lang="scss">

</style>